var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 8.00005C19.625 8.35785 19.4072 8.67959 19.075 8.81247L1.57497 15.8125C1.21696 15.9557 0.807417 15.8476 0.566614 15.5465C0.325812 15.2454 0.31052 14.8221 0.528965 14.5043L4.44942 8.80187L11.9999 8L4.41362 7.14618L0.528966 1.49577C0.310521 1.17803 0.325812 0.754752 0.566615 0.453605C0.807418 0.152459 1.21696 0.0444345 1.57497 0.187637L19.075 7.18764C19.4072 7.32052 19.625 7.64226 19.625 8.00005Z",
    fill: "#6C7794"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.eee793f2b2ac641a028002f20dfaa4d4.svg";
export { ForwardRef as ReactComponent };